export default function IosDivider() {
  return (
    <hr className="border-gray-200 dark:border-gray-50/[0.06]"></hr>
  );
}
